<script lang="ts">
    import { PositionType } from '@root/src/types';
    import ChipSimple from '../chips/chip-simple.svelte';
    import Chip from '../chips/chip.svelte';
    import clickSound from '../../../utils/useClickSound';

    let className = '';
    export { className as class };
    export let chipPosition: PositionType = 'left-top';
    export let chipValue: string = '';
    export let chipIndex = 0;
    export let disabled = false;
</script>

<div
    role="button"
    class="bg-gray-50 relative col-span-1 flex aspect-square justify-center overflow-hidden rounded-xl hover:brightness-110"
    class:pointer-events-none={disabled}
    class:opacity-60={disabled}
    on:click
    use:clickSound={{ sound: 'audio_basic_click', volume: 0.3 }}
>
    <div
        class="glow pointer-events-none absolute inset-0 h-full w-full overflow-hidden rounded-xl border-2 border-white/20"
    ></div>
    <div
        class="pointer-events-none absolute z-1000"
        class:left-top={chipPosition === 'left-top'}
        class:right-top={chipPosition === 'right-top'}
        class:left-bottom={chipPosition === 'left-bottom'}
        class:right-bottom={chipPosition === 'right-bottom'}
    >
        {#if chipValue}
            <Chip class="parent-chip h-7 w-7 text-md desktop:h-8 desktop:w-8" value={chipValue} index={chipIndex} />
        {:else}
            <ChipSimple class="top-1.5 h-7 w-7 desktop:h-8 desktop:w-8" />
        {/if}
    </div>

    <div class="pointer-events-none h-auto w-full {className}">
        <div class="flex h-full w-full items-center justify-center">
            <slot />
        </div>
    </div>
</div>

<style>
    :global(.left-top) {
        left: 0.375rem;
        top: 0.375rem;
    }
    :global(.left-bottom) {
        left: 0.375rem;
        bottom: 0.375rem;
    }

    :global(.right-top) {
        right: 0.375rem;
        top: 0.375rem;
    }
    :global(.right-bottom) {
        right: 0.375rem;
        bottom: 0.375rem;
    }

    .glow:after {
        content: '';
        width: 100%;
        position: absolute;
        height: 45%;
        border-radius: 0px 0px 50% 50%;
        background: linear-gradient(0deg, rgba(255, 255, 255, 0) -1.39%, #ffffff90 100%);
        background-blend-mode: screen;
    }
</style>
